/* TF · Fútbol · Tabs (comparación) — role=tab/tabpanel, teclado, carga diferida
 * del panel inactivo, transición suave (CSS). Respeta prefers-reduced-motion. */
(function () {
  'use strict';

  function loadPanel(panel) {
    if (!panel || panel.__tfLoaded) return; panel.__tfLoaded = true;
    panel.querySelectorAll('img[data-src]').forEach(function (img) {
      if (!img.getAttribute('src')) img.setAttribute('src', img.getAttribute('data-src'));
      img.removeAttribute('data-src');
    });
  }

  function init(root) {
    (root || document).querySelectorAll('[data-tf-tabs]').forEach(function (tablist) {
      if (tablist.__tfTabs) return; tablist.__tfTabs = true;
      var tabs = Array.prototype.slice.call(tablist.querySelectorAll('[role="tab"]'));
      var scope = tablist.closest('.tf-fcmp') || document;

      function panelFor(tab) { return scope.querySelector('#' + CSS.escape(tab.getAttribute('aria-controls'))); }

      function select(tab, focus) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var p = panelFor(t);
          if (p) { if (on) { p.hidden = false; loadPanel(p); } else { p.hidden = true; } }
        });
        if (focus) tab.focus();
      }

      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { select(tab, false); });
        tab.addEventListener('keydown', function (e) {
          var idx = null;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') idx = (i + 1) % tabs.length;
          else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') idx = (i - 1 + tabs.length) % tabs.length;
          else if (e.key === 'Home') idx = 0;
          else if (e.key === 'End') idx = tabs.length - 1;
          if (idx !== null) { e.preventDefault(); select(tabs[idx], true); }
        });
      });

      // Estado inicial: carga el panel activo declarado en el markup.
      var active = tabs.filter(function (t) { return t.getAttribute('aria-selected') === 'true'; })[0] || tabs[0];
      if (active) { var p = panelFor(active); if (p) loadPanel(p); }
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
